/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-26T10:02:19.87
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentFacilityTest,
	listRentFacilityTestInit,
	listRentFacilityTestByAuthorizations,
	deleteRentFacilityTest
	
} from '@api/rentmanage/RentFacilityTest';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentFacilityTest({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacilityTest(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentFacilityTestByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacilityTestByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentFacilityTestInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentFacilityTestInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentFacilityTest({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentFacilityTest({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
